export const base_url = typeof window !== 'undefined' && window.location.origin ? window.location.origin : ''
export const MAXSIZE = 4 * 1024 * 1024
export const GA_id = 'G-N0FD0B556M'

export const TRANSACTION_TYPES = [
  {
    label: 'Buy',
    type: 'buy',
  },
  {
    label: 'Sell',
    type: 'sell',
  },
  {
    label: 'Buy',
    type: 'buy',
  },
  {
    label: 'Deposit',
    type: 'deposit',
  },
  {
    label: 'Donation',
    type: 'donation',
  },
  {
    label: 'Deposit Event',
    type: 'depositEvent',
  },
  {
    label: 'Daily Checkins',
    type: 'dailyCheckins',
  },
  {
    label: 'Referral',
    type: 'referral',
  },
  {
    label: 'Claim Event',
    type: 'claimEvent',
  },
  {
    label: 'Promotion',
    type: 'promotion',
  },
]

export const TRANSACTION_STATUS = [
  {
    label: 'Successfully',
    status: 'done',
    color: 'text-green-500',
  },
  {
    label: 'Pending',
    status: 'pending',
    color: 'text-yellow-500',
  },
  {
    label: 'Failed',
    status: 'failed',
    color: 'text-red-500',
  },
]

export const NOTIFICATION_TYPE = {
  postRecent: 'postRecent',
  postMentionComment: 'postMentionComment',
  postLike: 'postLike',
  postComment: 'postComment',
  event: 'event',
  eventCohost: 'eventCohost',
  donate: 'donate',
  referral: 'referral',
  kol: 'kol',
  adminNotification: 'adminNotification',
  another: 'another',
  chat: 'chat',
  transaction: 'transaction',
  campaign: 'campaign',
  campaignKol: 'campaignKol',
}

export const TASK_TITLE = {
  followTwitter: 'Follow {input} account on X',
  joinTelegramChannel: 'Join channel {input} on Telegram',
  openHomePage: 'Visit Homepage of the {input}',
  watchYouTube: 'Visit {input} on YouTube',
  followKOLTwitter: 'Follow KOL {input} on X',
  likeTweetTwitter: 'Like {input} tweet to complete the task',
  retweetTwitter: 'Retweet {input} post to complete the task',
  inviteCampaign: 'Invite to join this Campaign',
}

export const TOKEN_INFO = {
  notDisclosed: 'Not Disclosed',
  presale: 'Presale',
  ICO: 'ICO',
  upcoming: 'Upcoming',
  released: 'Released',
}

export const SCORE = 0.0004
